export default "__VITE_ASSET__Ise$j1Lc__"